
import OptionDropDownRow from '@/components/OptionDropDown/OptionDropDownRow.vue';
import { defineComponent, ref } from 'vue';
import { onClickOutside } from '@vueuse/core';

export default defineComponent({
  name: 'UploadTypeDropDown',
  components: {
    OptionDropDownRow,
  },
  props: {
    type: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
    },
    havePermissionToDownload: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['onTypeChange'],
  setup(_props, { emit }) {
    const isOpen = ref(false);
    const wrapper = ref(null);

    onClickOutside(wrapper, () => {
      isOpen.value = false;
    });

    const selectType = (type: number) => {
      emit('onTypeChange', type);
      isOpen.value = false;
    };

    return {
      isOpen,
      wrapper,
      selectType,
    };
  },
});
